export const url = import.meta.env.DEV ? 'http://localhost:3001/api' : '/api'
